import type { AccountStageMeaning } from '../../constants/account-stage-meanings';
import { Column, Index, OneToMany } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

@Index('idx_ordinal', ['ordinal'], {})
@Index('idx_is_closed_type', ['isClosedType'], {})
@Index('unique_name', ['name', 'deletedDate'], {
	unique: true,
})
@Entity('client_lifecycle_stage', {}, { label: 'Client Lifecycle Stage' })
export class ClientLifecycleStageEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 100 })
	public name!: string;

	@Column('int', { name: 'ordinal', unsigned: true, default: () => "'0'" })
	public ordinal!: number;

	@Column({
		type: 'boolean',
		name: 'is_closed_type',
		width: 1,
		default: () => "'0'",
	})
	public isClosedType!: boolean;

	@Column('varchar', { name: 'color', nullable: true, length: 20 })
	public color!: string | null;

	/**
	 * PD-17595 — what the stage means (ACCOUNT_STAGE_MEANINGS), whatever it is
	 * called: the default Clients tabs, the closed-account rule, the new
	 * account's first stage and the automatic changes read it. Required by the
	 * stage service; nullable in the table so the column could be added before
	 * the instance migration filled it.
	 */
	@Column('varchar', { name: 'meaning', nullable: true, length: 32 })
	public meaning!: AccountStageMeaning | null;

	@OneToMany(() => ClientEntity, (client) => client.fkClientLifecycleStage, {})
	public clients!: Array<ClientEntity>;
}
